import api from '@/api/index.js'

const account_season_ticket = {
  state: {
    loading: false,
    updating: false,
    data: null,
    error: null,
    cancelTypes: ["refunded", "revoked"]
  },

  mutations: {
    SET_ACCOUNT_SEASON_TICKET_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_SEASON_TICKET_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_ACCOUNT_SEASON_TICKET: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_SEASON_TICKET_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    },
  },

  actions: {
    LoadAccountSeasonTicket({commit}, req) {
      commit('SET_ACCOUNT_SEASON_TICKET_LOADING', true)
      commit('SET_ACCOUNT_SEASON_TICKET_ERROR', null)
      return api.get(`accounts/${req.accountID}/season-tickets/${req.ID}`)
        .then((response) => {
          commit('SET_ACCOUNT_SEASON_TICKET', response)
          commit('SET_ACCOUNT_SEASON_TICKET_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_SEASON_TICKET_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
    UpdateAccountSeasonTicket({commit}, req) {
      commit('SET_ACCOUNT_SEASON_TICKET_UPDATING', true)
      commit('SET_ACCOUNT_SEASON_TICKET_ERROR', null)
      return api.put(`accounts/${req.accountID}/season-tickets/${req.ID}`, req.payload)
        .then((response) => {
          commit('SET_ACCOUNT_SEASON_TICKET', response.body)
          commit('SET_ACCOUNT_SEASON_TICKET_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_SEASON_TICKET_ERROR', error)
          commit('SET_ACCOUNT_SEASON_TICKET_UPDATING', false)
        })
    },
  },
}

export default account_season_ticket
